<template>
  <div class="max-w-5 min-w-5">
    <email-status v-if="isEmailLog(log) && log.data" :email="log.data" />
    <sms-status
      v-else-if="isSmsLog(log) && !!log.data?.status"
      :status="log.data.status"
      :status-message="log.data.status_message"
    />
    <icon-base
      v-else-if="isCallLog(log) && !!log.data?.recording"
      class="text-label"
      :icon="IconMicrophone"
      v-tooltip="$t('COMMUNICATION.RECORDING_AVAILABLE_MESSAGE')"
    />
  </div>
</template>
<script setup lang="ts">
import { isCallLog, isEmailLog, isSmsLog } from "@/helpers/communication";

import EmailStatus from "@/components/communicationLogs/communication/emailThread/EmailStatus.vue";
import SmsStatus from "@/components/communicationLogs/communication/sms/SmsStatus.vue";
import IconMicrophone from "@/components/icons/IconMicrophone.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { CommunicationLogBase } from "@/models/communicationLogs";

const { log } = defineProps<{ log: CommunicationLogBase }>();
</script>
